import { FC } from "react";
import { useScreenIsAboveBreakpoint } from "hooks/useScreenIsAboveBreakpoint";
import { ComponentMoleculesMenuPanel } from "types/graphql/generated";
import { BrickList } from "../../../Molecules/BrickList";
import { FeaturedLinksListWithBillboard } from "../FeaturedLinksListWithBillboard";
import { SubMenuPanel } from "../SubMenuPanel";

interface SubMenuPanelGroupProps {
  panels: ComponentMoleculesMenuPanel[];
}

const SubMenuPanelGroup: FC<SubMenuPanelGroupProps> = ({ panels }) => {
  const isDesktopView = useScreenIsAboveBreakpoint("lg");

  return (
    <>
      {panels.map((panel) => (
        <SubMenuPanel key={panel.id} bgColorType={panel.bgColorType}>
          {panel?.featureListWithBillboard && (
            <FeaturedLinksListWithBillboard
              content={panel.featureListWithBillboard}
              title={panel.title}
              className="lg:motion-safe:animate-slide-in"
            />
          )}
          {panel?.brickList && (
            <BrickList
              isMobile={!isDesktopView}
              content={panel?.brickList}
              title={panel.title}
              className="lg:motion-safe:animate-slide-in"
            />
          )}
        </SubMenuPanel>
      ))}
    </>
  );
};

export { SubMenuPanelGroup };
